module.exports = __webpack_public_path__ + "static/img/reversion.143cdb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/reversion.png
// module id = STr3
// module chunks = 15